import { Button, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTE_PATHS } from '@hero/routes';

import * as S from './style';

function EmptyCart({ translation, browseShoppingButtonEnabled = true }) {
  const navigate = useNavigate();
  const { emptyCartAddGiftTitle, emptyCartAddGiftDesc, emptyCartAddGiftButtonText } = translation;

  return (
    <S.CartEmpty>
      <Typography variant="body2SemiBold" style={{ marginTop: '16px' }}>
        {emptyCartAddGiftTitle}
      </Typography>
      <Typography
        color="neutral"
        variant="body2"
        emphasis="400"
        style={{ width: 240, marginTop: '4px' }}
      >
        {emptyCartAddGiftDesc}
      </Typography>
      {browseShoppingButtonEnabled && (
        <Button
          style={{ width: '100%', marginTop: 20 }}
          onClick={() => {
            navigate(ROUTE_PATHS.GIFT_CATALOG);
          }}
        >
          {emptyCartAddGiftButtonText}
        </Button>
      )}
    </S.CartEmpty>
  );
}

export { EmptyCart };
